import { PropTypes } from 'prop-types'

const AuthCard = ({ title, children, footer }) => {
  return (
    <div className="flex flex-col w-full h-full border border-border rounded-lg bg-widgetBackground">
      <header className="px-4 py-2">
        <h1 className="text-left text-lg font-semibold">{title}</h1>
      </header>

      <main className={`flex-grow p-4 bg-navbarBackground ${footer ? '' : 'rounded-b-lg'}`}>{children}</main>

      {footer && (
        <footer className="auth-footer px-4 py-2 bg-background text-center rounded-br-lg rounded-bl-lg">
          {footer}
        </footer>
      )}
    </div>
  )
}
AuthCard.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
}

export default AuthCard
